// extracted by mini-css-extract-plugin
export default {"container":"ThemeSwitcher_container__Pqre0"};